// src/auth/keycloak.js
import Keycloak from 'keycloak-js';
import {
  KEYCLOAK_URL,
  KEYCLOAK_REALM,
  KEYCLOAK_CLIENT_ID,
} from '../config/env';


import { setHttpAuthToken } from '../api/http';


export const keycloak = new Keycloak({
  url: KEYCLOAK_URL,          // e.g., http://localhost:8180
  realm: KEYCLOAK_REALM,      // e.g., cognifog-local
  clientId: KEYCLOAK_CLIENT_ID // e.g., cognifog-web
});

export async function initKeycloak() {
  // Initialize SSO
  const authenticated = await keycloak.init({
    onLoad: 'login-required',
    pkceMethod: 'S256',
    checkLoginIframe: false,
  });

  // Set the token once for all HTTP calls
  setHttpAuthToken(keycloak.token);

  // Keep token fresh in background
  setInterval(async () => {
    try {
      const refreshed = await keycloak.updateToken(60); // refresh if <60s left
      if (refreshed) setHttpAuthToken(keycloak.token);
    } catch (e) {
      // Optional: handle refresh failure (e.g., prompt login)
      // console.warn('Token refresh failed', e);
    }
  }, 30000); // check every 30s

  // Also react to the built-in expiration event
  keycloak.onTokenExpired = async () => {
    await ensureFreshToken();
    setHttpAuthToken(keycloak.token);
  };

  return authenticated;
}

export function getToken() {
  return keycloak.token;
}

export async function ensureFreshToken() {
  try {
    await keycloak.updateToken(30); // refresh if <30s left
  } catch {
    // If refresh failed (e.g., session gone), go to login and come back here
    await keycloak.login({ redirectUri: window.location.href });
  }
}

export function hasRole(role) {
  return keycloak.hasRealmRole(role);
}

export function logout() {
  setHttpAuthToken(null);
  // After KC ends the session, come back to the app root
  // which immediately triggers 'login-required' → KC login page.
  return keycloak.logout({ redirectUri: window.location.origin + '/' });
}